module.exports = __webpack_public_path__ + "img/r-3-actbtn.74168cbd.png";